import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { DailyActivityState } from "../types";

const selectDomain = (state?: RootState) =>
  state?.dailyActivityState || DailyActivityState;

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectDailyActivityId = createSelector(
  [selectDomain],
  (state) => state.dailyActivityId
);

export const selectDuplicateDailyActivityId = createSelector(
  [selectDomain],
  (state) => state.duplicateDailyActivityId
);

export const selectList = createSelector([selectDomain], (state) => state.list);
export const selectQuery = createSelector(
  [selectDomain],
  (state) => state.query
);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
